import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ROUTES from '../constants/routes';

/**
 * PublicRoute component for routes that don't require authentication
 * Can optionally redirect authenticated users away from certain pages (login, register)
 */
const PublicRoute = ({ children, restrictAuthenticated = false }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();

  // If user is authenticated and route is restricted (like login/register)
  // Redirect to dashboard or the page they were trying to access
  if (isAuthenticated && restrictAuthenticated) {
    const { from } = location.state || { from: ROUTES.DASHBOARD };
    return <Navigate to={from} replace />;
  }

  // Render the public component
  return children;
};

export default PublicRoute; 